import { useNavigate } from 'react-router-dom';
import { ENDPOINTS } from 'utils/endpoints';

export function useAppNavigation() {
  const navigate = useNavigate();

  return {
    back: () => navigate(-1),
    forward: () => navigate(1),
    home: () => navigate(ENDPOINTS.home),
    go: (path: string, state?: any) => navigate(path, { state }),

    // refresh: reload nhưng vẫn giữ nguyên URL
    refresh: () => {
      // React k reload được trực tiếp → phải dùng trình duyệt
      window.location.reload();
    },

    // replace trang hiện tại (không push vào history)
    replace: (path: string, state?: any) => navigate(path, { replace: true, state }),
  };
}
